<lib-page-container [title]="title" [loading]="screen.isLoading()" [version]="appVersion.version" [apiVersion]="appVersion.apiVersion$ | async">
  <div lib-page-breadcrumbs>
    <lib-breadcrumbs></lib-breadcrumbs>
  </div>
  <div lib-page-actions>
    <lib-button [disabled]="screen.isLoading()" *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE]" icon="save" tooltip="Save" (buttonClick)="onSave()">Save</lib-button>
  </div>
  <div lib-page-body>
    <div fxLayout="row" fxFlexFill fxLayoutGap="16px">
      <app-campaign-base-edit #campaignBase [campaign]="campaign" [isStaffCampaign]="true" (isContactSync)="isContactSync" fxFlex="490px"></app-campaign-base-edit>


      <mat-card appearance="outlined" fxFlex class="mat-typography">
        <mat-card-content>
          <mat-tab-group class="tab-group">
            <mat-tab label="Strategy">
              @if (campaign) {
                <app-information-strategy #campaignStrategy
                  [advertiserId]="advertiserId"
                  [strategy]="campaign.strategy"
                  [isConsumerCampaign]="isConsumerCampaign"
                  [advertiser]="advertiser"
                  [rewardProducts]="rewardProducts">
                </app-information-strategy>
              }
            </mat-tab>
            <mat-tab label="Locations">
              <app-campaign-location-filters #campaignLocationFilters [campaignId]="campaignId"></app-campaign-location-filters>
            </mat-tab>
            @if (isConsumerCampaign) {
              <mat-tab label="Consumer Referral">
                <app-consumer-referral-tab #consumerReferralTab [isConsumerInfo]="isConsumerCampaign" [campaignId]="campaignId" [advertiserId]="advertiserId"></app-consumer-referral-tab>
              </mat-tab>
              <mat-tab label="Staff Referral">
                <app-staff-referral-tab #staffReferralTab [campaignId]="campaignId" [advertiserId]="advertiserId"></app-staff-referral-tab>
              </mat-tab>
            }
            <mat-tab label="Json">
              <pre>{{ campaign | json }}</pre>
            </mat-tab>
            @if (campaignId) {
              <mat-tab label="Media">
                <app-campaign-media #campaignMedia [campaignId]="campaignId"></app-campaign-media>
              </mat-tab>
            }
            <mat-tab label="Banner">
              <app-campaign-banner #campaignBanner></app-campaign-banner>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                Outbound Events
                @if (campaignOutboundEvents && campaignOutboundEvents.isValid() === false) {
                  <mat-icon class="tab-icon">warning</mat-icon>
                }
              </ng-template>
              <app-campaign-outbound-events #campaignOutboundEvents [campaignId]="campaignId"></app-campaign-outbound-events>
            </mat-tab>
          </mat-tab-group>
        </mat-card-content>
      </mat-card>

    </div>
  </div>
</lib-page-container>